import http from '@/api/http';
import { serialize } from '@/utils/tools';

export async function listCompany(token) {

    try {

        // console.log(query);

        const response = await http.get('api/v1/company/list',
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function getCompany(token, id) {

    try {

        // console.log(query);

        const response = await http.get('api/v1/company?id=' + id,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}


export async function updateCompany(token, data) {
    try {
        let dataParam = {
            'title': data.title,
            'description': data.description,
        }
        if (data.id > 0) {
            dataParam['id'] = data.id
        }

        const response = await http.post('api/v1/company',
            dataParam,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function archCompany(token, companyId, flag) {
    try {
        let dataParam = {
            'id': companyId
        }

        if (flag !== null) {
            dataParam['all_projects'] = flag
        }

        const response = await http.post('api/v1/company/arhive', 
            dataParam,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        if (error.response.data && error.response.data.code == 35) {
            return error.response.data
        }
        return null
    }
}

export async function archCompanyRestore(token, companyId, flag) {
    try {
        let dataParam = {
            'id': companyId
        }

        if (flag !== null) {
            dataParam['all_projects'] = flag
        }

        const response = await http.get(
            'api/v1/company/arhive', 
            {
                params: dataParam,
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function trashCompany(token, companyId, flag) {
    try {
        const dataParam = { id: companyId }

        if (flag !== null) {
            dataParam['all_projects'] = flag
        }        

        const response = await http.post(
            'api/v1/company/trash', 
            dataParam,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        if (error.response.data && error.response.data.code == 35) {
            return error.response.data
        }        
        return null
    }
}

export async function trashCompanyRestore(token, companyId, flag) {
    try {
        const dataParam = { id: companyId }

        if (flag !== null) {
            dataParam['all_projects'] = flag
        }  

        const response = await http.get(
            'api/v1/company/trash', 
            {
                params: { id: companyId },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function delCompany(token, id) {
    try {
        const response = await http.delete('api/v1/company?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function inviteCode(token, data) {
    try {
        let dataParam = {
            'id': data.id,
            'role': data.role,
        }

        const response = await http.get('api/v1/company/link-code?' + serialize(dataParam), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return error.response.data
    }
}

export async function sendInvitation(token, data) {
    try {
        let dataParam = {
            'code': data.code
        }

        const response = await http.post('api/v1/role/add-key',
            dataParam,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
